import { MediaListItem as MediaListItemResp } from "@jconradi/tutu-porn-api-client/src/users"
import { useGallery } from "../../../hooks/useGallery";
import { useCallback, useState } from "react";
import { useSwipeable } from "react-swipeable";
import { GalleryThumbnails } from "./GalleryThumbnails";
import ChevronLeft from "../../../public/images/icons/chevron-left.svg";
import ChevronRight from "../../../public/images/icons/chevron-right.svg";
import { GalleryItem } from "./GalleryItem";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import Lightbox, { Slide } from "yet-another-react-lightbox";
import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css'

export interface GalleryProps {
    media: MediaListItemResp;
    [rest: string]: any;
}
export const Gallery = ({ media }: GalleryProps) => {
    const galleryQuery = useGallery(media.gallery!);
    const [open, setOpen] = useState(false);
    const [index, setIndex] = useState(0);
    const handlers = useSwipeable({
        onSwipedLeft: () => { goLeft() },
        onSwipedRight: () => { 
            goRight();
        },
        onTap: (e) => {
            if (galleryQuery.data?.data.media[index].mediaType === 'photo') {
                setOpen(true);
            }
        },
        preventScrollOnSwipe: true,
        trackMouse: true
      },);

      const goRight = () => {
        setIndex((index + 1) % (galleryQuery.data!.data.media.length))
      }

      const goLeft = () => {
        if (index === 0) {
            setIndex(galleryQuery.data!.data.media.length  - 1)
        }
        else {
            setIndex((i) => i - 1)
        }
      }

    return (
        <>
            <div className="absolute inset-0 mb-[64px]" {...handlers} >
                {!galleryQuery.isLoading && <GalleryItem media={galleryQuery.data?.data.media[index]!} /> }
            </div>
            {galleryQuery.isLoading && <Skeleton className="absolute inset-0" />}

            <GalleryThumbnails media={media} setIndex={setIndex} index={index} />
            <button onClick={goLeft} className="absolute top-0 bottom-0 left-0 w-[32px]" style={{
                'background': 'linear-gradient(90deg,rgba(0,0,0,.4) 8%,transparent 92%)'
            }}>
                <ChevronLeft className="" />
            </button>

            <button onClick={goRight} className="absolute top-0 bottom-0 right-0 w-[32px] " style={{
                'background': 'linear-gradient(270deg,rgba(0,0,0,.4) 8%,transparent 92%)'
            }}>
                <ChevronRight className="" />
            </button>
            {!galleryQuery.isLoading &&
                <Lightbox open={open} close={() => setOpen(false)}
                    render={{
                        iconNext: () => { return null },
                        iconPrev: () => { return null },
                    }}
                    plugins={[Zoom]}
                    zoom={{
                        maxZoomPixelRatio: 5,
                        scrollToZoom: true
                    }}
                    slides={[{ src: galleryQuery.data?.data.media[index].urls.poster! }]} />
            }

            
        </>
    )

}